module.exports = __webpack_public_path__ + "static/media/no-heavy.744ebab7.svg";